import React from "react";

import {
  Modal as BootstrapModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormFeedback,
  Button
} from "reactstrap";
import { fields } from "../../common/lib/redux-fields";
import { ValidationError } from "../../common/lib/validation";
import { connect } from "react-redux";

import { create } from "../../common/application/actions";
import { clearError, clearForm } from "../../common/application/actions";
import Input from "../components/Form/Input";
import ButtonWithLoader from "../components/Form/ButtonWithLoader";

const formFields = ["firstName", "lastName", "email", "phoneNumber", "policy1"];

class Modal extends React.Component {
  constructor() {
    super();

    this.create = this.create.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    const { fields, clearForm } = this.props;

    fields.$reset();
    clearForm();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async create(e) {
    const { fields, toggleAction } = this.props;
    const { create, clearForm, offerUID } = this.props;
    e.preventDefault();
    const values = fields.$values();

    values.offerUID = offerUID;
    const rs = await create(values);

    if (rs && rs.status >= 200 && rs.status <= 299) {
      fields.$reset();
      clearForm(true);

      setTimeout(toggleAction, 3000);
      setTimeout(clearForm, 3000);

      if (typeof ga !== typeof undefined) {
        window.ga("send", "event", {
          eventCategory: "email",
          eventAction: "success",
          eventLabel: "application"
        });
      }
    } else {
      if (typeof ga !== typeof undefined) {
        window.ga("send", "event", {
          eventCategory: "email",
          eventAction: "error",
          eventLabel: "application"
        });
      }
    }
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  render() {
    const { isOpen, toggleAction, form, isSent, fields } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;

    return (
      <BootstrapModal
        className="offer-modal"
        isOpen={isOpen}
        toggle={toggleAction}
      >
        {!isSent && (
          <ModalHeader toggle={toggleAction}>
            Podaj dane, dzięki którym będziemy się mogli z Tobą skontaktować
          </ModalHeader>
        )}
        <ModalBody className="form-width">
          {!isSent && (
            <Form onSubmit={this.create} className="row" noValidate>
              <Input
                className="col-xs-12 col-sm-6"
                size="lg"
                field="firstName"
                placeholder="Imię"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "firstName")}
                {...fields.firstName}
              />
              <Input
                className="col-xs-12 col-sm-6"
                size="lg"
                field="lastName"
                placeholder="Nazwisko"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "lastName")}
                {...fields.lastName}
              />
              <Input
                className="form-input col-xs-12"
                size="lg"
                field="email"
                placeholder="Adres email"
                type="email"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "email")}
                {...fields.email}
              />
              <Input
                className="form-input col-xs-12"
                size="lg"
                field="phoneNumber"
                placeholder="Telefon kontaktowy"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "phoneNumber")}
                {...fields.phoneNumber}
              />
              <Input
                className="col-xs-12 form-group-last"
                field="policy1"
                title="Akceptuję politykę prywatności"
                type="checkbox"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "policy1")}
                {...fields.policy1}
              />
              <ButtonWithLoader
                className="col-xs-12 full-width-button"
                size="lg"
                color={"primary"}
                text={"Wprowadź dane"}
                isLoading={form.get("loading")}
                loadingText={"Wysyłanie aplikacji..."}
                isDirty={dirty}
                dirtyText={"APLIKUJ"}
              />
            </Form>
          )}
          {isSent && (
            <FormFeedback className="form-success application-feedback">
              Aplikacja została przyjęta. Dziękujemy!
            </FormFeedback>
          )}
        </ModalBody>
      </BootstrapModal>
    );
  }
}

Modal.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Modal = fields(Modal, {
  path: "applicationForm",
  fields: formFields,
  getInitialState: () => {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      policy1: false
    };
  }
});

Modal = connect(
  state => ({
    form: state.application.form,
    isSent: state.application.isSent
  }),
  { create, clearError, clearForm }
)(Modal);

export { Modal, formFields };
export default Modal;



/** WEBPACK FOOTER **
 ** ./src/browser/offer/Modal.js
 **/